import ChangeEntryStatus from './Admin/Components/ChangeEntryStatus'
import Clipboard from './Admin/Components/Clipboard'
import DocumentUploader from './Admin/Components/DocumentUploader'

window.Components = {}
window.Components.changeEntryStatus = ChangeEntryStatus
window.Components.documentUploader = DocumentUploader
window.Components.clipboard = Clipboard
